import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import MainPage from 'features/mainPage';
import { useConfiguratorsContext } from 'hooks/useConfiguratorsContext';

const Page = () => {
  const { loaded } = useConfiguratorsContext();
  return (
    <MainLayout ready={loaded}>
      <MainPage />
    </MainLayout>
  );
};

export default Page;
